import { render, staticRenderFns } from "./EmbeddedYotiSign.vue?vue&type=template&id=3230c9af&scoped=true&"
import script from "./EmbeddedYotiSign.vue?vue&type=script&lang=js&"
export * from "./EmbeddedYotiSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3230c9af",
  null
  
)

export default component.exports